import React from 'react';
import { useTranslation } from 'react-i18next';
import { AnyFieldApi } from '@tanstack/react-form';
import { UserSelectorDropDown } from '@/shared/components/user-selector';
import { useEmployees } from '@/shared/hooks';
import { FieldInfo } from '@/shared/components/form/FieldInfo';

interface OwnerSelectorProps {
  form: any;
}

export const OwnerSelector: React.FC<OwnerSelectorProps> = ({ form }) => {
  const { t } = useTranslation('goals');

  const { data: employees = [] } = useEmployees({
    isActive: true,
    isDeleted: false,
  });

  const userSelectorEmployees = employees.map((emp) => ({
    id: emp._id,
    firstName: emp.personalInfo.firstName,
    lastName: emp.personalInfo.lastName,
    fullName: `${emp.personalInfo.firstName} ${emp.personalInfo.lastName}`,
    isActive: emp.isActive,
    imageUrl: emp.personalInfo.imageUrl,
  }));

  return (
    <form.AppField name="creator">
      {(field: AnyFieldApi) => (
        <div className="space-y-2">
          <label className="text-sm font-medium text-gray-900">
            {t('ownerLabel')}
          </label>
          <UserSelectorDropDown
            variant="inline"
            className={
              field.state.meta.errors.length > 0 ? 'border-red-500' : ''
            }
            employees={userSelectorEmployees}
            selectedEmployees={field.state.value ? [field.state.value] : []}
            onSelectionChange={(selectedIds) =>
              field.handleChange(selectedIds[0] || '')
            }
            multiSelect={false}
            customSelectionText={
              field.state.value
                ? userSelectorEmployees.find(
                    (emp) => emp.id === field.state.value
                  )?.fullName || t('selectOwner')
                : t('selectOwner')
            }
          />

          <FieldInfo field={field} />
        </div>
      )}
    </form.AppField>
  );
};
